import { useCallback, useEffect, useState } from "react";
import { fetchQuestionBank } from "util/questionBankApi";

// The company question bank for the survey builder: its questions and whether the user may
// add to it. Reloaded when the builder opens and after the user adds a question.
export default function useQuestionBank(enabled = true) {
  const [bank, setBank] = useState({ can_manage: false, questions: [] });

  const reload = useCallback(async () => {
    const res = await fetchQuestionBank();
    if (res && !res.error) setBank({ can_manage: !!res.can_manage && !res.read_only, questions: res.questions || [] });
  }, []);

  useEffect(() => {
    if (enabled) reload();
  }, [enabled, reload]);

  return [bank, reload];
}

// The fields a survey question takes from its bank question.
export const BANK_FIELDS = [
  "type",
  "text",
  "ratingScale",
  "options",
  "answerLength",
  "urlDomain",
  "videoMinSeconds",
  "videoMaxSeconds",
  "videoInstructions",
  "topic",
];

export function bankFields(question) {
  const out = {};
  BANK_FIELDS.forEach((key) => {
    if (question[key] !== undefined && question[key] !== null && question[key] !== "") out[key] = question[key];
  });
  if (Array.isArray(out.options)) out.options = out.options.map((o) => (o || "").trim()).filter(Boolean);
  return out;
}
